<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="margin-top: 2%">
       

        <v-card>
            <v-card-title>

                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher un administrateur ..."
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                                   :headers="headers"
                                   :items="users"
                                   :search="search"
                                   sort-by="name"
                                   class="elevation-1"
                                   :loading="users==undefined" loading-text="Chargement en cours...">


                               <template v-slot:top>
                                   <v-toolbar flat color="white">
                                       <v-spacer></v-spacer>
                                       <v-dialog v-model="dialog"  style="z-index: 9999" max-width="500px">
                                           <template v-slot:activator="{ on }">
                                               <v-btn style="background: #2A3042;color: #fff" class="mb-2" v-on="on">Nouvel utilisateur
                                               </v-btn>
                                           </template>
                                           <v-card>
                                               <v-card-title>
                                                   <span class="headline">{{ formTitle }}</span>
                                               </v-card-title>

                                               <v-card-text>


                                                   <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                       <v-alert v-if="errors" dense outlined
                                                                :type="(errors.update_error)?'error':'success'">
                                                           {{errors.operation}}
                                                       </v-alert>

                                                       <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
                                                       <v-row>
                                                           <v-col cols="12" sm="6" md="12">
                                                               <v-text-field
                                                                       clearable :rules="nameRules" v-model="editedItem.name"
                                                                             label="Nom complet" placeholder="ex : Patrick SODJINNIN"></v-text-field>
                                                           </v-col>
                                                           <v-col cols="12" sm="6" md="12">
                                                               <v-text-field
                                                                       clearable :rules="emailRules" v-model="editedItem.email"
                                                                             label="Email" placeholder="ex : sodjinninpatrick@gmail.com"></v-text-field>
                                                           </v-col>

                                                           <v-col cols="12" sm="6" md="12">

                                                               <v-text-field
                                                                       :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                                       :type="show1 ? 'text' : 'password'"
                                                                       @click:append="show1 = !show1"
                                                                       clearable v-model="editedItem.password"
                                                                             label="Mot de passe" placeholder="******"></v-text-field>

                                                           </v-col>


                                                       </v-row>
                                                   </v-form>
                                               </v-card-text>

                                               <v-card-actions>
                                                   <v-spacer></v-spacer>
                                                   <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                   <v-btn color="blue darken-1"  :disabled="!valid" text @click="save">Sauvegarder</v-btn>
                                               </v-card-actions>
                                           </v-card>
                                       </v-dialog>
                                   </v-toolbar>
                               </template>
                               <template v-slot:item.actions="{ item }">
                                   <v-icon small class="mr-2" @click="editItem(item)">
                                       mdi-pencil
                                   </v-icon>
                                   <v-icon small @click="deleteItem(item)">
                                       mdi-delete
                                   </v-icon>
                               </template>
                               <template v-slot:no-data>
                                   <v-btn color="default" @click="initialize">Actualiser</v-btn>
                               </template>
                           </v-data-table>
        </v-card>

        <v-snackbar
                v-model="snackbar"
                timeout="2000"
        >
            {{ textSnack }}

            <template v-slot:action="{ attrs }">
                <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                >
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>


    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";

     export default {
        name: "User",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                id: undefined,
                snackbar: false,
                user: JSON.parse(localStorage.getItem("user")),
                textSnack: '',
                show1: false,
                headers: [
                    {
                        text: 'Nom complet',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {text: 'Email', value: 'email'},
                    {text: 'Actions', value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                emailRules: [
                    v => !!v || 'Email requis',
                ]
                ,
                passwordRules: [
                   v => !!v || 'Mot de passe requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvel utilisateur" : "Mise à jour"
            }
            ,
            ...mapState('users/', ['users'])

        }
        ,
        mounted() {
           
            this.$store.dispatch('users/getByType',"suntechdev").then(response => {
                window.console.log('users', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,

            editItem(item) {
                this.editedIndex = this.users.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem.password='';
                this.dialog = true;
            }
            ,

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('users/deleteUser', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("email", this.editedItem.email);
                data.append("name", this.editedItem.name);
                data.append("password", this.editedItem.password);
                let mineroute = 'users/setUser';
                if (this.editedIndex>-1){
                    data.append("id",this.editedItem._id);
                    mineroute = 'users/setUpdateUser';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>